export enum JobOpeningCrucialRequirementPriority {
  NiceToHave = 'niceToHave',
  MustHave = 'mustHave',
}

export enum JobOpeningCrucialRequirementCategory {
  Education = 'education',
  Technology = 'technology',
  DomainKnowledge = 'domainKnowledge',
  Visa = 'visa',
  WorkingConditions = 'workingConditions',
}

export type JobOpeningCrucialRequirement = {
  name: string;
  description?: string | null;
  priority: JobOpeningCrucialRequirementPriority;
  category: JobOpeningCrucialRequirementCategory;
};

export type CrucialRequirementsByJobOpeningId = Record<
  string,
  JobOpeningCrucialRequirement[]
>;

export interface ICrucialRequirementsBody {
  additionalSkills: string[];
  educations: string[];
  domains: string[];
  visas: string[];
  workingConditions: string[];
}
